import React, { useState } from "react";
import { Empty, Pagination } from "antd";
import JobPostCard from "./JobPostCard";
import { useMyApplications } from "../../../Hooks/useMyApplications";
import { findAllJobPostDto } from "../../../Interface/Index";
import { JobApplication } from "../../../Entities/job-application.entity";

interface SavedApplicationsProps {
  jobApplications: JobApplication[];
}

const SavedApplications: React.FC<SavedApplicationsProps> = ({
  jobApplications,
}) => {
  const [filters, setFilters] = useState<findAllJobPostDto>({
    page: 1,
    limit: 9,
    position: [],
    searchQuery: null,
  });

  const { userJobApplications, pageData } = useMyApplications(filters);

  const handlePageChange = (page: number) => {
    setFilters({ ...filters, page });
  };

  return (
    <div className="job-listing__card-body">
      {userJobApplications.length > 0 ? (
        <div className="job-listing__grid">
          {userJobApplications.map((userApplication) => {
            const isApplied = jobApplications.some(
              (application) =>
                application.jobPost._id === userApplication.jobPost._id,
            );

            return (
              <JobPostCard
                key={userApplication._id}
                _id={userApplication.jobPost._id}
                title={userApplication.jobPostDetails.title}
                position={userApplication.jobPostDetails.position}
                description={userApplication.jobPostDetails.description}
                slug={userApplication.jobPostDetails.slug}
                isApplied={isApplied}
                isActive={userApplication.jobPostDetails.isActive}
              />
            );
          })}
        </div>
      ) : (
        <div className="job-listing__no-results">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No Job Applications found"
          />
        </div>
      )}

      <div className="job-listing__pagination">
        <Pagination
          current={filters.page || 1}
          total={pageData.total}
          pageSize={filters.limit || 10}
          onChange={handlePageChange}
          showSizeChanger={false}
          className="job-listing__pagination-antd"
        />
      </div>
    </div>
  );
};

export default SavedApplications;
